import { useEffect, useRef } from 'react';

import _ from 'lodash';

import { getFormOptionValue } from 'utils/form';

import { NOT_RUN_YET } from './constants';

/**
 * Keeps two form paths that save to the same column equal while both are in the form (only one
 * section renders at a time, but the form keeps every visited section's fields). On mount the
 * section takes the other path's value, the newer one; afterwards its own edits are written
 * through to the other path.
 * @param {object} params
 * @param {object} params.form
 * @param {Function} params.setInForm
 * @param {string} params.path  this section's form path
 * @param {string} params.mirrorPath  the other section's form path for the same column
 */
const useMirroredFormValue = ({ form, setInForm, path, mirrorPath }) => {
  const previousValueRef = useRef(NOT_RUN_YET);

  const value = _.get(form, path);
  const mirrorValue = _.get(form, mirrorPath);
  const hasMirror = _.has(form, mirrorPath);

  useEffect(() => {
    const isOwnEdit =
      previousValueRef.current !== NOT_RUN_YET && previousValueRef.current !== value;

    previousValueRef.current = value;

    if (!hasMirror || getFormOptionValue(value) === getFormOptionValue(mirrorValue)) {
      return;
    }

    if (isOwnEdit) {
      setInForm(mirrorPath, value, false);

      return;
    }

    setInForm(path, mirrorValue, false);
  }, [hasMirror, mirrorPath, mirrorValue, path, setInForm, value]);
};

export default useMirroredFormValue;
